import { HttpError, RQAPICallWithData } from 'store/APIClient';
import { useMutation } from '@tanstack/react-query';

const toggleAlertMute = async (
    alertId: number,
    muted: boolean,
): Promise<{ message: string }> => {
    const response = await RQAPICallWithData({
        endpoint: `alert/${alertId}/muted`,
        method: 'PATCH',
        body: {
            muted,
        },
    });
    return response.content;
};

/**
 * RQ Mutation to mute or unmute the related alert. We need the source and the sourceId here
 * to write the new value in the cache.
 * @param {number} alertId - The id of the alert to mute or unmute
 * @param onSuccess
 * @param onError
 */
export const useToggleAlertMute = (
    alertId: number,
    onSuccess?: (message: string) => void,
    onError?: (error: HttpError) => void,
) =>
    useMutation({
        mutationFn: (muted: boolean) => toggleAlertMute(alertId, muted),

        onSuccess: ({ message }) => {
            if (onSuccess) {
                onSuccess(message);
            }
        },

        onError: (error: HttpError) => {
            if (onError) {
                onError(error);
            }
        },
    });
